export default __webpack_public_path__ + "static/media/USDT.70fb0ec1.svg";